import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import InputMask from "react-input-mask";

const DateComp = ({ dob, setDob }) => {
   return (
      <DatePicker
         popperProps={{ positionFixed: true }}
         onSelect={(date) => {
            setDob(date);
         }}
         value={dob}
         selected={dob}
         showMonthDropdown
         showYearDropdown
         dropdownMode="select"
         wrapperClassName="w-100 h-100"
         className="p-4 w-100  h-small fonts-dob-comp-new"
         autoComplete="off"
         placeholderText="mm/dd/yyyy"
         dateFormat="MM/dd/yyyy"
         maxDate={new Date()}
         customInput={
            <InputMask mask="99/99/9999" className="fonts-dob-comp-new">
               {(inputProps) => <input {...inputProps} />}
            </InputMask>
         }
      />
   );
};

export default DateComp;
